// src/components/common/Modal.js

import React from 'react';

export default function Modal({ 
    title, 
    message, 
    onConfirm, 
    onCancel, 
    confirmText = "Confirmar", 
    confirmColor = "bg-cyan-500", 
    showCancelButton = true,
    isLoading = false
}) {
    return (
        <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md flex justify-center items-center z-[200] animate-fadeIn p-4">
            <div className="bg-slate-900 rounded-3xl border border-slate-700 p-8 shadow-[0_0_50px_-12px_rgba(0,0,0,0.5)] w-full max-w-md transform animate-scaleIn relative overflow-hidden">
                {/* Decorative background glow */}
                <div className={`absolute -top-24 -right-24 w-48 h-48 rounded-full opacity-10 blur-3xl ${confirmColor === 'bg-red-500' ? 'bg-red-500' : 'bg-cyan-500'}`}></div>
                
                <h3 className={`text-2xl font-black mb-4 uppercase tracking-tight ${confirmColor === 'bg-red-500' ? 'text-red-400' : 'text-cyan-400'}`}>
                    {title}
                </h3>
                
                <p className="text-slate-300 mb-8 leading-relaxed font-medium">
                    {message}
                </p>
                
                <div className="flex flex-col sm:flex-row justify-end gap-3">
                    {showCancelButton && (
                        <button 
                            type="button"
                            onClick={onCancel} 
                            disabled={isLoading}
                            className="px-6 py-3 rounded-2xl bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold transition-all order-2 sm:order-1 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Cancelar
                        </button>
                    )}
                    <button 
                        type="button"
                        onClick={onConfirm} 
                        disabled={isLoading}
                        className={`px-8 py-3 rounded-2xl ${confirmColor} hover:opacity-90 text-white font-black uppercase tracking-widest shadow-lg shadow-black/20 transition-all order-1 sm:order-2 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed`}
                    >
                        {isLoading ? (
                            <>
                                <div className="animate-spin h-4 w-4 border-2 border-white/30 border-t-white rounded-full"></div>
                                <span>Processando...</span>
                            </>
                        ) : (
                            confirmText
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}